<template>
    <div>
        <div class="pa-3">
            <v-card class="pt-2 px-3">
                <v-layout row class="mx-2 mb-2 mt-2">
                    <div
                        style="border: 2px solid rgb(76, 175, 80); border-radius: 5px;"
                        class="pa-2 font-weight-regular"
                    >
                        Call<span class="mx-1 font-weight-medium"
                            >646-349-1934</span
                        >
                        Pin#<span class="mx-1 font-weight-medium">1234</span>
                        to record your audio
                    </div>
                </v-layout>
                <v-layout class="mx-3 mt-3" row>
                    <div
                        style=""
                        class="pt-3 text-xs-center font-weight-medium title"
                    >
                        Files ({{ filesToDisplay.length }})
                    </div>
                    <v-spacer></v-spacer>
                    <v-text-field
                        style="max-width: 250px;"
                        label="Search"
                        v-model="search"
                        hide-details
                        @input="onSearch"
                        clearable
                        class="mx-2 mt-0 pb-1"
                    ></v-text-field>
                    <v-menu
                        v-model="datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-calendar"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="fromDate"
                                :value="fromDate"
                                label="From Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                class="mx-2 mt-0 pb-1"
                                style="max-width: 200px"
                                hide-details
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fromDate"
                            @change="fromDateChanged(fromDate)"
                        ></v-date-picker>
                    </v-menu>
                    <v-btn
                        :disabeld="loadingAudio"
                        small
                        color="success"
                        :loading="uploading"
                        @click="pickFile()"
                        ><v-icon dark left>mdi-cloud-upload</v-icon
                        >Upload</v-btn
                    >
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept=".mp3, .wav"
                        @change="onFilePicked($event)"
                    />
                    <v-btn
                        @click="loadAudioLibrary"
                        :disabeld="loadingAudio"
                        small
                        color="success"
                        ><v-icon dark left>mdi-reload</v-icon>Reload
                        Library</v-btn
                    >
                </v-layout>

                <div style="height: 800px; overflow-y: auto;" class="mx-3 mb-3">
                    <v-layout
                        row
                        class="pa-2 mb-2"
                        justify-space-between
                        v-for="(audio, index) in audioLibrary"
                        @click="selectAudio(audio)"
                        style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                    >
                        <!-- <v-checkbox
                            style="max-width: 40px;"
                            v-model="audio.selected"
                            color="success"
                            class="ml-2 mt-2 pt-2 pr-3"
                            hide-details
                        ></v-checkbox> -->
                        <div class="pt-3 pl-3 font-weight-regular">
                            {{ audio.date | time }}
                        </div>
                        <v-layout justify-center class="width-350">
                            <div
                                v-if="!audio.editing"
                                class="pt-3 font-weight-regular"
                            >
                                {{ audio.name }}
                            </div>
                            <v-btn
                                class="my-0 pt-2"
                                v-if="!audio.editing"
                                @click.stop="editAudio(audio)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-text-field
                                class="pr-0 my-0 mr-3"
                                hide-details
                                v-if="audio.editing"
                                label="Name"
                                v-model="audio.name"
                            ></v-text-field>
                            <v-btn
                                class=""
                                v-if="audio.editing"
                                small
                                dark
                                @click.stop="cancelAudioName(audio)"
                                color="default"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                class="mr-3"
                                v-if="audio.editing"
                                small
                                @click.stop="saveAudioName(audio)"
                                color="success"
                            >
                                Save
                            </v-btn>
                        </v-layout>

                        <div class="pt-3 width-250">
                            <span class="font-weight-regular mr-1">From:</span>
                            <span v-if="audio.callerID != 'ADMIN PORTAL'">{{
                                audio.callerID | phone
                            }}</span>
                            <span v-else>{{ audio.callerID }}</span>
                        </div>
                        <div style="width: 10%" class="pt-3">
                            <span
                                v-if="audio.user"
                                class="font-weight-regular mr-1"
                                >User:</span
                            >
                            <span v-if="audio.user">{{ audio.user }}</span>
                        </div>
                        <div style="width: 10%" class="pt-3">
                            <span
                                v-if="audio.branch"
                                class="font-weight-regular mr-1"
                                >Branch:</span
                            >
                            <span v-if="audio.branch">{{ audio.branch }}</span>
                        </div>
                        <audio controls :src="audio.recordingURL"></audio>
                        <v-btn
                            class="my-0 pt-2"
                            @click.stop="openDeleteAudioDialog(audio)"
                            flat
                            icon
                            color="success"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-layout justify-center>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="7"
                            v-on:input="setPagianation"
                        ></v-pagination>
                    </v-layout>
                </div>
            </v-card>
            <v-dialog persistent v-model="deleteAudioDialog" max-width="400">
                <v-card class="pa-2">
                    <v-card-title class="text-warning headline"
                        >Are You Sure?</v-card-title
                    >
                    <v-card-text class="mb-3 py-0">
                        You will now delete {{ audioToDelete.name }} audio file
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="deleteAudioDialog = false"
                            >Close</v-btn
                        >
                        <v-btn
                            :loading="deleting"
                            color="success"
                            @click="deleteAudio()"
                            >Delete</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            audioLibraryDialog: false,
            audioLibrary: [],
            files: [],
            audioFile: "",
            selectedAudio: "",

            deleteAudioDialog: false,
            deleting: false,
            uploading: false,
            audioToDelete: "",
            search: "",
            filesToDisplay: [],
            datePickerMenu: false,
            fromDate: "",

            pagination: {
                totalCount: 0,
                rowsPerPage: 9,
                page: 1,
            },

            all: [],
        };
    },
    async created() {
        this.loadAudioLibrary();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.filesToDisplay.length / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    methods: {
        async loadAudioLibrary() {
            this.loadingAudio = true;

            const audioLibrary = await this.$http.get(
                "api/broadcast/getAudioLibrary",
            );

            this.all = audioLibrary
                .map((audio) => {
                    audio.selected = false;
                    audio.editing = false;
                    audio.name = audio.name ? audio.name : "Unnamed";

                    return audio;
                })
                .filter((audio) => {
                    if (
                        this.$store.state.authentication.branch &&
                        !this.$store.state.authentication.branch.includes(
                            "null",
                        )
                    ) {
                        const branches = this.$store.state.authentication.branch.split(
                            ",",
                        );
                        const audioBranches = audio.branch
                            ? audio.branch.split(",")
                            : [];

                        return (
                            audio.branch &&
                            (branches.some((b) => b == audio.branch) ||
                                audioBranches.some((ab) =>
                                    branches.some((br) => br == ab),
                                ))
                        );
                    }

                    return true;
                });

            this.filesToDisplay = this.all;
            this.audioLibrary = this.all.slice(0, 9);

            this.loadingAudio = false;
            this.pagination.page = 1;
        },
        onSearch(value) {
            this.filesToDisplay = [];

            if (!value) {
                this.filesToDisplay = this.all;
            } else {
                this.filesToDisplay = this.all.filter((a) =>
                    a.name
                        ? a.name
                              .toLowerCase()
                              .includes(value.trim().toLowerCase())
                        : false,
                );
            }

            this.audioLibrary = this.filesToDisplay.slice(0, 9);
            this.pagination.page = 1;
        },

        fromDateChanged(value) {
            this.filesToDisplay = [];

            if (!value) {
                this.filesToDisplay = this.all;
            } else {
                const date = new Date(value);

                this.filesToDisplay = this.all.filter(
                    (a) => new Date(a.date) >= date,
                );
            }

            this.audioLibrary = this.filesToDisplay.slice(0, 9);
            this.pagination.page = 1;
        },
        editAudio(audio) {
            audio.editing = true;
            audio.originalName = audio.name;
        },
        cancelAudioName(audio) {
            audio.name = audio.originalName;
            audio.editing = false;
        },
        async saveAudioName(audio) {
            audio.editing = false;

            await this.$http.post(
                "api/broadcast/updateAudioName?id=" +
                    audio.id +
                    "&name=" +
                    audio.name,
            );

            this.loadAudioLibrary();
        },
        openDeleteAudioDialog(audio) {
            this.audioToDelete = audio;

            this.deleteAudioDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);
                const authBranch = this.$store.state.authentication.branch;
                const branch =
                    authBranch && !authBranch.includes("null") ? authBranch : "";

                const response = await this.$http.post(
                    "api/broadcast/uploadAudioFile?user=" +
                        this.$store.state.authentication.user +
                        "&branch=" +
                        branch,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.audioFile = response.url;
                this.selectedAudio = response.audio;

                this.uploading = false;

                this.loadAudioLibrary();
            } catch (e) {
                this.uploading = false;
            }
        },
        async deleteAudio() {
            this.deleting = true;

            await this.$http.post(
                "api/broadcast/deleteAudio?id=" + this.audioToDelete.id,
            );

            this.deleting = false;
            this.deleteAudioDialog = false;

            this.loadAudioLibrary();
        },
        selectAudio(audio) {
            this.audioLibrary
                .filter((a) => a.recordingURL != audio.recordingURL)
                .forEach((a) => (a.selected = false));

            audio.selected = true;

            this.selectedAudio = audio;
            this.audioFile = audio.recordingURL;

            this.audioLibraryDialog = false;
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.audioLibrary = this.filesToDisplay.slice(
                number,
                number + this.pagination.rowsPerPage,
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
    },
};
</script>
<style></style>
